// import SocialLinks from "../../common/SocialLinks/SocialLinks";
import SocialLinks from "../../common/SocialLinks/SocialLinks.jsx";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <SocialLinks />
      </div>
    </footer>
  );
}

export default Footer;